import './fixPublicPath'
import '@/entries/common'
import { initAndStartVueMachine } from '@/scripts'
initAndStartVueMachine()
